var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, computed } from "mobx";
export class DropDownListPortalController {
    constructor() {
        this.top = 0;
        this.left = 0;
        this.width = 0;
        this.heigth = 0;
    }
    get styleProperties() {
        return {
            width: `${this.width}px`,
            left: `${this.left}px`,
            top: `${this.top}px`
        };
    }
    getTopPosition(listHeight, selectHeight, selectBottom, selectTop) {
        let spaceUnderElement = window.innerHeight - selectBottom - listHeight;
        return spaceUnderElement <= 0 ? selectTop - listHeight + window.scrollY : selectHeight + selectTop + window.scrollY;
    }
    prepareStyleProperties(list, select) {
        if (list && select) {
            let { left, width, height, top, bottom } = select.getBoundingClientRect();
            let { height: listHeight } = list.getBoundingClientRect();
            this.width = width;
            this.heigth = listHeight;
            this.left = window.scrollX + left;
            this.top = this.getTopPosition(listHeight, height, bottom, top);
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], DropDownListPortalController.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DropDownListPortalController.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DropDownListPortalController.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], DropDownListPortalController.prototype, "heigth", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DropDownListPortalController.prototype, "styleProperties", null);
//# sourceMappingURL=DropDownListPortalController.js.map